var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled, { ThemeContext } from "styled-components";
import * as Atoms from "./atoms";
import { breakPointArrayCleanerRem } from "../../utils";

var Panel = function Panel(props) {
  var theme = useContext(ThemeContext);

  var mt = props.mt,
      mb = props.mb,
      _props$align = props.align,
      align = _props$align === undefined ? "left" : _props$align,
      background = props.background,
      restProps = _objectWithoutProperties(props, ["mt", "mb", "align", "background"]);

  if (align === null) {
    if (theme.typoTextAlign === "center") {
      align = "center";
    } else {
      align = "left"; // default
    }
  }

  return React.createElement(
    Atoms.Outer,
    { background: background },
    React.createElement(
      Atoms.Panel,
      _extends({
        mt: breakPointArrayCleanerRem(mt),
        mb: breakPointArrayCleanerRem(mb),
        align: align
      }, restProps),
      props.children
    )
  );
};

export { Panel };
Panel.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  mt: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))]),
  mb: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))]),
  align: PropTypes.string,
  background: PropTypes.bool
} : {};

Panel.defaultProps = {
  mt: 0,
  mb: 0,
  align: null,
  background: false
};

Panel.displayType = "Panel";